import { Box, CircularProgress, Tooltip, Typography } from "@mui/material";

import { IconBox, IconBoxMain } from "@/pages/COMMON/documents/styles";
import { IconImage } from "@/components";
import { ContainedButton } from "@/common";
import { delete_img, download_img, link_img } from "@/constants";
import { formatDateOrTime } from "@/utils";
// import { formatDateOrTime } from "@/utils";

interface IColumnActions {
  action: (type: "download" | "delete", doc: DocDataTypes) => void;
  actionsLoading: { delete: string[]; download: string[] };
}

export const columns = ({
  action,
  actionsLoading,
}: IColumnActions): IColumn<DocDataTypes>[] => [
  {
    name: "Document Type",
    key: "documentType",
    align: "left",
    width: "16%",
    minWidth: "120px",
    component: (doc) => (
      <Typography variant="body2" sx={{ fontSize: { xs: '11px', md: '12px' } }}>{doc.documentType}</Typography>
    ),
  },
  {
    name: "Entry Number",
    key: "filerCodeAndEntryNo",
    align: "left",
    width: "26%",
    minWidth: "180px",
    component: (doc) => (
      <IconBoxMain gap={1}>
        <IconBox>
          <IconImage src={link_img} size="auto" />
        </IconBox>
        <Tooltip title={doc.filerCodeAndEntryNo} arrow>
          <Typography variant="body2" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: { xs: '11px', md: '12px' } }}>{doc.filerCodeAndEntryNo}</Typography>
        </Tooltip>
      </IconBoxMain>
    ),
  },
  {
    name: "Entry Date",
    key: "entryDate",
    align: "left",
    width: "14%",
    minWidth: "110px",
    component: (doc) => {
      const parts = doc.entryDate?.split("/");
      let dateToRender = null;
      if (parts?.length !== 3) {
        dateToRender = doc.entryDate || "N/A";
      } else {
        const [month, day, shortYear] = parts;
        const fullYear = shortYear.startsWith("20")
          ? shortYear
          : `20${shortYear}`;
        dateToRender = `${fullYear}-${month}-${day}`;
      }

      return <Typography variant="body2" sx={{ fontSize: { xs: '11px', md: '12px' } }}>{dateToRender}</Typography>;
    },
  },
  {
    name: "ADD/CVD Case #(s)",
    key: "ADD_CVV",
    align: "left",
    width: "24%",
    minWidth: "180px",
    component: (doc) => (
      <Tooltip title={doc?.ADD_CVV?.map((item) => item).join(", ")} arrow>
        <Typography variant="body2" sx={{ fontSize: { xs: '11px', md: '12px' }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {doc?.ADD_CVV?.map((item) => item).join(", ")}
        </Typography>
      </Tooltip>
    ),
  },
  {
    name: "Date Added",
    key: "createdAt",
    align: "left",
    width: "14%",
    minWidth: "110px",
    component: (doc) => (
      <>
        <Typography variant="body2" color={"#030712"} sx={{ fontSize: { xs: '11px', md: '12px' } }}>
          {formatDateOrTime(doc.createdAt, "date")}
        </Typography>
        <Typography variant="body1" fontSize={"0.75rem"} color={"#8E9494"}>
          {formatDateOrTime(doc.createdAt, "time")}
        </Typography>
      </>
    ),
  },
  {
    name: "Actions",
    key: "actions",
    align: "center",
    width: "16%",
    minWidth: "180px",
    component: (doc) => {
      const { _id } = doc;

      const isDownloading = actionsLoading["download"].includes(_id);
      const isDeleting = actionsLoading["delete"].includes(_id);
      return (
        <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
          <ContainedButton
            startIcon={
              isDownloading ? (
                <CircularProgress size={18} sx={{ color: "#030712" }} />
              ) : (
                <IconImage src={download_img} size="auto" />
              )
            }
            style={{
              borderColor: "#E6E7E7",
              color: "#030712",
              fontWeight: 500,
              whiteSpace: 'nowrap'
            }}
            variant="outlined"
            title="Download"
            disabled={isDownloading}
            onClick={() => action("download", doc)}
          />
          <ContainedButton
            startIcon={
              isDeleting ? (
                <CircularProgress size={18} sx={{ color: "#EA4334" }} />
              ) : (
                <IconImage src={delete_img} size="auto" />
              )
            }
            style={{
              color: "#EA4334",
              borderColor: "#E6E7E7",
              fontWeight: 500,
              whiteSpace: 'nowrap'
            }}
            variant="outlined"
            title="Delete"
            disabled={isDeleting}
            onClick={() => action("delete", doc)}
          />
        </Box>
      );
    },
  },
];
